import React, {Component} from 'react';
import {Link} from 'react-router-dom';

export default class Title extends Component {
    extractPath(link) {
        const url = document.createElement('a');
        url.href = link;

        return link.replace(`${url.protocol}//${url.host}`, '');
    }
    
    parentPath(link){
        const short_path = this.extractPath(link);
        var path_array = [];
        var path_array = short_path.split("/");
        //remove empty values
        path_array = path_array.filter(function (el) {
			return el != "";
		});

        console.log(path_array)
        
        if (path_array.length > 2){
	        return "/" + path_array[0] + "/" + path_array[1];
        } else {
	        return false;
        }
    }

    getClasses() {
        return this.props.isSingle ? 'title-block' : 'card-title';
    }

    render() {
        console.log(this.props);
        const link = this.extractPath(this.props.link);
        return (
            <header className={this.getClasses()}>
                {this.parentPath(this.props.link) && 
                <div className="nav-back">
                	<Link to={this.parentPath(this.props.link)}>{'<'}</Link>
                </div> }
                <Link to={link}><h1
                    dangerouslySetInnerHTML={ {__html: this.props.children} }/>
                </Link>
            </header>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/main/article/title.js